import { React, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import Icon from '@mdi/react';
import { mdiPlus, mdiMinus, mdiInformationVariant } from '@mdi/js';
import { useIntl } from 'react-intl';
import { useLocaleAutoSwitch } from 'i18n/localeUtils';

const useAriaZoomControls = () => {
    const intl = useIntl();
    useLocaleAutoSwitch();
    useEffect(() => {
        const zoomInElement = document.querySelector('.ol-zoom-in');
        if (zoomInElement) {
            zoomInElement.setAttribute('title', intl.formatMessage({ id: 'mapPreview.zoom.in' }));
            zoomInElement.setAttribute('aria-label', intl.formatMessage({ id: 'mapPreview.zoom.in' }));
            zoomInElement.setAttribute('data-testid', 'mapPreview.zoom.in');
            ReactDOM.createRoot(zoomInElement).render(<Icon path={mdiPlus} size={0.8} />);
        }
        const zoomOutElement = document.querySelector('.ol-zoom-out');
        if (zoomOutElement) {
            zoomOutElement.setAttribute('title', intl.formatMessage({ id: 'mapPreview.zoom.out' }));
            zoomOutElement.setAttribute('aria-label', intl.formatMessage({ id: 'mapPreview.zoom.out' }));
            zoomOutElement.setAttribute('data-testid', 'mapPreview.zoom.out');
            ReactDOM.createRoot(zoomOutElement).render(<Icon path={mdiMinus} size={0.8}/>);
        }
        const mapAttributationIcon = document.querySelector('.ol-attribution-expand');
        if (mapAttributationIcon) {
            ReactDOM.createRoot(mapAttributationIcon).render(<Icon path={mdiInformationVariant} size={0.8}/>);
        }
        const mapAttributationButton = document.querySelector('button[aria-expanded="false"][title="Attributions"]');
        if (mapAttributationButton) {
            mapAttributationButton.setAttribute('title', intl.formatMessage({ id: 'mapPreview.attribution' }));
            mapAttributationButton.setAttribute('aria-label', intl.formatMessage({ id: 'mapPreview.attribution.information' }));
        }
    }, []);

    return null;
};

export default useAriaZoomControls;
